import script from "./FreeTextInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./FreeTextInput.vue?vue&type=script&setup=true&lang=ts"

import "./FreeTextInput.vue?vue&type=style&index=0&id=2c96ae52&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c96ae52"]])

export default __exports__